/**
 * Behavior for sections/spaces-events-timeline.liquid, ported from the approved static
 * demo's inline <script> (landings_demo_v1.html) — the scroll-synced timeline scrubber
 * only (marker visibility, drag-to-navigate range input, active-event detection).
 *
 * The demo's mobile-menu-toggle and header-ink-detection logic already live in
 * assets/header-immersive.js (it watches every [data-header-ink] element on the page,
 * not just this section's), so they aren't duplicated here.
 */
(function () {
  function init(root) {
    if (root.dataset.timelineReady === 'true') return;
    root.dataset.timelineReady = 'true';

    var marker = root.querySelector('[data-timeline-marker]');
    var events = Array.prototype.slice.call(root.querySelectorAll('.landing-event'));
    if (!marker || !events.length) return;

    var date = marker.querySelector('[data-timeline-date]');
    var city = marker.querySelector('[data-timeline-city]');
    var range = marker.querySelector('[data-timeline-range]');
    var header = document.querySelector('.site-header');

    function updateTimelineVisibility() {
      var revealLine = (header ? header.offsetHeight : 0) + 12;
      var firstRect = events[0].getBoundingClientRect();
      var lastRect = events[events.length - 1].getBoundingClientRect();
      marker.classList.toggle('is-visible', firstRect.top <= revealLine && lastRect.bottom > revealLine);
    }

    function updateTimeline(index) {
      var panel = events[index - 1];
      var progress = events.length > 1 ? ((index - 1) / (events.length - 1)) * 100 : 0;
      range.value = String(index);
      range.setAttribute('aria-valuetext', panel.dataset.date + ', ' + panel.dataset.city);
      date.textContent = panel.dataset.date;
      city.textContent = panel.dataset.city;
      marker.style.setProperty('--timeline-progress', progress + '%');
    }

    function setActive(panel) {
      updateTimeline(Number(panel.dataset.index));
    }

    range.addEventListener('input', function () {
      var index = Number(range.value);
      updateTimeline(index);
      events[index - 1].scrollIntoView({ behavior: 'auto', block: 'start' });
    });

    var eventObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) setActive(entry.target);
      });
    }, { rootMargin: '-46% 0px -46% 0px', threshold: 0 });

    events.forEach(function (panel) {
      eventObserver.observe(panel);
    });

    updateTimeline(1);
    // capture: true — this theme's actual scroll container is a nested wrapper
    // (.page-wrapper), not window/document. Scroll events on a scrollable
    // descendant don't bubble to window, but capture-phase listeners on an
    // ancestor still see them, so this is what makes the listener fire at all.
    window.addEventListener('scroll', updateTimelineVisibility, { passive: true, capture: true });
    window.addEventListener('resize', updateTimelineVisibility);
    updateTimelineVisibility();
  }

  function initAll() {
    document.querySelectorAll('.timeline-experience').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-renders the section in place (no full page reload) on setting changes.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('.timeline-experience');
    if (root) init(root);
  });
})();
